import React from 'react'

import './regionSelect.scss'

export default function RegionSelect({ onChange }) {

    return (
        <div className='regionSelectWrapper'>
            <div className='regionSelectContainer'>
                <h2>Please select a Province</h2>
                <div className='provinceContainer'>
                    <button type='button' onClick={() => onChange('AB')}>Alberta</button>
                    <button type='button' onClick={() => onChange('BC')}>British Columbia</button>
                    <button type='button' onClick={() => onChange('MB')}>Manitoba</button>
                    <button type='button' onClick={() => onChange('NB')}>New Brunswick</button>
                    <button type='button' onClick={() => onChange('NL')}>Newfoundland and Labrador</button>
                    <button type='button' onClick={() => onChange('NT')}>Northwest Territories</button>
                    <button type='button' onClick={() => onChange('NS')}>Nova Scotia</button>
                    <button type='button' onClick={() => onChange('NU')}>Nunavut</button>
                    <button type='button' onClick={() => onChange('ON')}>Ontario</button>
                    <button type='button' onClick={() => onChange('PE')}>Prince Edward Island</button>
                    <button type='button' onClick={() => onChange('QC')}>Quebec</button>
                    <button type='button' onClick={() => onChange('SK')}>Saskatchewan</button>
                    <button type='button' onClick={() => onChange('YT')}>Yukon Territory</button>
                </div>
            </div>
        </div>
    )

}

export function SubscriptionPastDue() {
    return (
        
        <div className='regionSelectWrapper'>
            <div className='regionSelectContainer'>
                <h2>Your subscription is past-due</h2>
                <p style={{color:'white'}}>Please contact <a href="mailto:dane@dsmedia.ca">dane@dsmedia.ca</a> to renew your subscription.</p>
                </div>
                </div>
    )
}